module.exports = __webpack_public_path__ + "static/media/reception-custom.84af4c7f.svg";